import React, { Component, useLayoutEffect, useEffect, useState, useRef, useImperativeHandle } from "react";
import store from "@/redux/store";
import { Navigate, useNavigate } from "react-router-dom";

import { PlusIcon } from '@heroicons/react/20/solid'

import { ArrowPathIcon, CalendarIcon, TruckIcon } from '@heroicons/react/24/outline'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import messageSlice from "@/redux/messageSlice";

import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import {TimerPanel} from '@/views/TimeRegistration/TimerPanel'
import {AddButton} from '@/views/base/Buttons/AddButton'
import { DayView } from "../Agenda/DayView";
import Interval,{ INTERVAL_TYPES } from "@/packages/interval"; 
import { useTranslation } from "react-i18next";

const projects = [


  { name: 'Mijn taken', initials: 'T', href: '#', open: 0, ip:4, bgColor: 'bg-pink-600', shortname:"taken" },
  { name: 'Dossiers', initials: 'D', href: '#', members: 0, bgColor: 'bg-purple-600', shortname:"dossiers" },
  { name: 'Klanten', initials: 'K', href: '#', members: 2, bgColor: 'bg-yellow-500' , shortname:"klant" },
  { name: 'Medewerkers', initials: 'M', href: '#', members: 4, bgColor: 'bg-green-500', shortname:"medewerker" },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function sendMessage(projectItem) {
    store.dispatch(messageSlice.actions.submitMessage({action: "SET_USER", payload: projectItem }));
}

export function Dashboard ({ ...props }) {
    const navigate = useNavigate();
    const [startTourVar, setstartTourVar] = useState(0);
    const [worktype, setWorktype] = useState();
    
    useEffect(() => {
        if(!worktype) {
            const state = store.getState();
            const {InvoiceReducer} = state;
            const {workTypes} = InvoiceReducer;
            
            setWorktype(workTypes);
            //props.invoiceRow.timeregistrations = props.data; //DB.newCollection(props?.data);
            //setTableItems(props.invoiceRow.timeregistrations);
        }
        return () => {
        };
      }, [worktype, setWorktype, props]);    
    
    const startTour=((event) => {
        setstartTourVar(1);
    })
useEffect(() => {    // Update the document title using the browser API    document.title = `You clicked ${count} times`;  });
     
       if(startTourVar == 1) {
const driverObj = driver({
  showProgress: true,
  steps: [
    { element: '#menuBar', popover: { title: 'Navigatie panel', description: 'Aan de linker kant van het dashboard vind u het navigatie panel. Hier worden de verschillende menu items getoond waartoe u de rechten heeft.', side: "left", align: 'center' }},
    { element: '#myprofile', popover: { title: 'Mijn profiel', description: 'Al uw persoonlijke gegevens en instellingen zijn te vinden uw persoonlijke profiel.', side: "left", align: 'start' 
    ,onNextClick: () => {
           navigate("/myprofile");
          // .. load element dynamically
          // .. and then call
          driverObj.moveNext();
        }}
    },
    { element: 'nav#myProfileTab a#tabId1', popover: { title: 'Mijn gegevens', description: 'U kunt hier uw persoonlijke NAW gegevens behren', side: "left", align: 'start' }},
    { element: 'nav#myProfileTab a#tabId4', popover: { title: 'Mijn documenten', description: 'In de tab "Mijn documenten" kunt u uw persoonlijke documenten uploaden zoals bv rijbewijs, paspoort ed.', side: "left", align: 'start' }},
    { element: 'nav#myProfileTab a#tabId2', popover: { title: 'Interesse profiel', description: 'Hier kunt u uw interesses aangeven.', side: "left", align: 'start' }},
    { popover: { title: 'Einde tour', description: 'Bij eventuele vragen kunt altijd onze online help tour opnieuw starten.' } }
  ]
});

driverObj.drive();   
}   
    }, [startTourVar]);    
    
    const showMessage = store.getState()?.AuthReducer.messages;
  return (
    <>
 
      <div className= "headerPanels fixed w-full h-full top-[100px]">

      <div className="grid grid-cols-12 gap-2"> 
      <div className= "headerPanels col-span-6">
      <div className="fixed h-full w-2/6 h-[calc(100%-110px)]">
      <DayView items={store.getState().AuthReducer.calenderEvents} maxMonths="1" nochange={true} baseView={true}/>
      </div>
      </div>
            <div className= "headerPanels col-span-6">
              <ul role="list" className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
              {props?.user?.ppc_user_fields && props?.user?.ppc_user_fields.map((project) => (
                  
                  <li key={project.fieldkey} className="" >
                    <div className="col-span-1 flex rounded-md shadow-sm">
                    <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
                      <div className="flex-1 truncate px-4 py-2 text-sm">
                      Alias : {project?.data?.alias}<br/>
                      {project?.data?.creator === true &&
                      <p>U kunt artikelen schrijven</p>
                      }
                      {project?.data?.reactions === true &&
                      <p>U kunt reageren op artikelen</p>
                      }
                        <a href={props?.pavillion_url} target="_blank" className="font-medium text-gray-900 hover:text-gray-600">
                          Klik hier om naar het paviljoen te gaan
                        </a>
                      </div>
                    </div>
                    </div>
                  </li>
                  ))}
              </ul>

              
            
      
      
      
      
            </div>
      </div>
    </div>
    


   
    </>
  )
}